import { User } from '@domain/user';
import { useGenericQuery } from '@hooks/use-generic-query';
import { GenericQueryOptions } from '@hooks/use-generic-query.type';
import { UseQueryResult } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';
import i18n from 'i18next';

import { QUERY_KEYS } from './constants.type';

const getUserByToken = async () => {
  const url = `${import.meta.env.VITE_USERS_HOST}/v1/me`;

  const user = (await request({ url, method: RequestMethod.GET })) as User;
  // Applied before resolving so the auth render gate only mounts the app once the user's language is
  // active: requests fired on mount would otherwise send the browser language as `Accept-Language`.
  // Same-language calls still emit `languageChanged`, re-rendering every `useTranslation` consumer.
  if (user.lang && user.lang !== i18n.language) await i18n.changeLanguage(user.lang);
  return user;
};

export const useGetUser = (options?: GenericQueryOptions<User, RequestError>): UseQueryResult<User, RequestError> => {
  return useGenericQuery<User, RequestError>(
    [QUERY_KEYS.getUser],
    () => getUserByToken(),
    {
      ...options,
      meta: {
        ...options?.meta,
        hideLoader: true,
      },
    },
    true
  );
};
